import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_tac _mt-4" }
const _hoisted_2 = { class: "_mb-1" }
const _hoisted_3 = { class: "_fw-b" }
const _hoisted_4 = { class: "_fw-b" }
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { class: "gfu-box gfu-box--huge" }, {
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gfu-box__title--success" }, null, -1 /* CACHED */)),
      _cache[7] || (_cache[7] = _createElementVNode("h2", {
        class: "gfu-heading gfu-hd gfu-hd--h1 gfu-box__title",
        "data-qa": "unsubscribe-successful"
      }, "Unsubscribe successful!", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_2, [
            _cache[1] || (_cache[1] = _createTextVNode(" You will no longer receive ", -1 /* CACHED */)),
            _createElementVNode("span", _hoisted_3, _toDisplayString($options.notificationTopicDisplayText), 1 /* TEXT */),
            _cache[2] || (_cache[2] = _createTextVNode(" emails", -1 /* CACHED */)),
            ($props.contextName)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[0] || (_cache[0] = _createTextVNode(" about ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_4, _toDisplayString($props.contextName), 1 /* TEXT */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _cache[3] || (_cache[3] = _createTextVNode(". ", -1 /* CACHED */))
          ]),
          _createElementVNode("div", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" Visit your ", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: $options.subscriptionManagementUrl,
              class: "gfu-link gfu-link--accent"
            }, "communication preferences", 8 /* PROPS */, _hoisted_5),
            _cache[5] || (_cache[5] = _createTextVNode(" for more notification settings. ", -1 /* CACHED */))
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }))
}